import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ModalService } from 'src/app/services/modal.service';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-assign-student-schedule-confirm',
  templateUrl: './assign-student-schedule-confirm.component.html',
  styleUrls: ['./assign-student-schedule-confirm.component.scss']
})
export class AssignStudentScheduleConfirmComponent implements OnInit {

  data!: any;

  constructor(
    private store: Store<AppState>,
    private modalService: ModalService
  ) { }

  ngOnInit() {
    console.log(this.data);
  }

  submit(){
    const payload = {
      schedule_id: this.data?.schedule?.id,
      selected_detail_ids: this.data?.selected_detail_ids,
      preview: this.data?.preview
    }
    this.store.dispatch(setLoadingSpinner({status: true}));
    // this.store.dispatch(generateStudentSchedule({data: payload, student: this.data?.student, schedule: this.data?.schedule}))
  }

  dismiss(){
    this.modalService.hideAssignStudentScheduleConfirm();
  }
}
